@let tooltipData = this.tooltipData();
@let svgIcon = this.svgIcon();
@let iconUrl = this.iconUrl();
@let defaultIcon = this.defaultIcon();
@let appButtonType = this.appButtonType();
@let linkUrl = this.linkUrl();

<ng-template #buttonContent>
    @if (svgIcon) {
        <app-icon [attr.data-qa]="qaTag() + '-icon'"
                  [svgIcon]="svgIcon"
                  aria-hidden="true"
                  class="button-icon"/>
    } @else if (iconUrl && defaultIcon) {
        <app-icon [iconUrl]="{url: iconUrl, fallback: defaultIcon}" aria-hidden="true" class="button-icon"/>
    }
    @if (appButtonType === AppButtonTypeEnum.TEXT_ONLY_BUTTON || appButtonType === AppButtonTypeEnum.ICON_WITH_TEXT_BUTTON) {
        <span [attr.data-qa]="qaTag() + '-text'" class="button-text">{{ buttonText() }}</span>
    }
</ng-template>

@if (linkUrl) {
    <a (click)="handleButtonClick($event)"
       (keyup)="handleKeyUp($event)"
       (pointercancel)="handlePointerCancel()"
       (pointerdown)="handlePointerDown($event)"
       (pointerup)="handlePointerUp($event)"
       [appTooltipDataQaTag]="tooltipData?.tooltipDataQaTag || qaTag() + '-tooltip'"
       [appTooltipIsDisabled]="tooltipData?.tooltipIsDisabled || !tooltipData?.tooltipText"
       [appTooltipPosition]="tooltipData?.tooltipPosition || TooltipPositionEnum.BOTTOM"
       [appTooltipStyle]="tooltipData?.tooltipStyle || TooltipStyleEnum.DEFAULT"
       [appTooltipText]="tooltipData?.tooltipText || ''"
       [attr.aria-disabled]="isDisabled() ? 'true' : null"
       [attr.data-qa]="qaTag()"
       [attr.href]="isDisabled() ? null : linkUrl"
       [class.has-icon-only]="appButtonType === AppButtonTypeEnum.ICON_ONLY_BUTTON"
       [class.is-long-press]="isLongPressButton()"
       [class.is-pulsing]="isPulsing()"
       [class.vertical-text]="appButtonType === AppButtonTypeEnum.ICON_WITH_TEXT_BUTTON && verticalText()"
       [ngClass]="cssClasses()"
       appTooltip
       class="app-button"
       rel="noopener noreferrer"
       target="_blank">
        @if (appButtonType === AppButtonTypeEnum.ICON_ONLY_BUTTON) {
            <span class="visually-hidden">{{ buttonText() }}</span>
        }
        <ng-container [ngTemplateOutlet]="buttonContent"/>
    </a>
} @else {
    @if (appButtonType === AppButtonTypeEnum.ICON_ONLY_BUTTON) {
        <label [attr.data-qa]="qaTag() + '-label'" class="visually-hidden" for="button">{{ buttonText() }}</label>
    }
    <button (click)="handleButtonClick($event)"
            (keyup)="handleKeyUp($event)"
            (pointercancel)="handlePointerCancel()"
            (pointerdown)="handlePointerDown($event)"
            (pointerup)="handlePointerUp($event)"
            [appTooltipDataQaTag]="tooltipData?.tooltipDataQaTag || qaTag() + '-tooltip'"
            [appTooltipIsDisabled]="tooltipData?.tooltipIsDisabled || !tooltipData?.tooltipText"
            [appTooltipPosition]="tooltipData?.tooltipPosition || TooltipPositionEnum.BOTTOM"
            [appTooltipStyle]="tooltipData?.tooltipStyle || TooltipStyleEnum.DEFAULT"
            [appTooltipText]="tooltipData?.tooltipText || ''"
            [attr.data-qa]="qaTag()"
            [attr.disabled]="isDisabled() ? '' : null"
            [class.has-icon-only]="appButtonType === AppButtonTypeEnum.ICON_ONLY_BUTTON"
            [class.is-long-press]="isLongPressButton()"
            [class.is-pulsing]="isPulsing()"
            [class.vertical-text]="appButtonType === AppButtonTypeEnum.ICON_WITH_TEXT_BUTTON && verticalText()"
            [ngClass]="cssClasses()"
            [type]="buttonType()"
            appTooltip
            class="app-button"
            id="button">
        <ng-container [ngTemplateOutlet]="buttonContent"/>
    </button>
}
